import banner1 from 'assets/icons/1783148333953_194284037513614117_4642898201278877177_0807db0806d4340ac4b91ae8f85890dd.jpg';
import banner2 from 'assets/icons/1783148333933_194284037513614117_4642898201278877177_f1f620bd0bbdcd527d40b8c60a1160af.jpg';
import banner3 from 'assets/icons/1783148333967_194284037513614117_4642898201278877177_e888358da2926ee81df9b264aae828e9.jpg';

let mockCategories = [
  { id: 1, name: 'Banner Trang Chủ', description: 'Hiển thị banner lớn ở trang chủ', displayOrder: 1 },
  { id: 2, name: 'Banner Khuyến Mãi', description: 'Banner thông báo các chương trình sale', displayOrder: 2 },
  { id: 3, name: 'Banner Popup', description: 'Popup quảng cáo khi mới vào web', displayOrder: 3 },
];

let mockBanners = [
  { id: 1, categoryId: 1, image: banner1, name: 'Banner Khuyến Mãi Tết', displayOrder: 1, status: 'ACTIVE', position: 'banner_tong_quan' },
  { id: 2, categoryId: 2, image: banner2, name: 'Sản Phẩm Bán Chạy', displayOrder: 2, status: 'ACTIVE', position: 'banner_san_pham' },
  { id: 3, categoryId: 1, image: banner3, name: 'Flash Sale Cuối Tuần', displayOrder: 3, status: 'INACTIVE', position: 'banner_don_hang' },
];

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const bannerApi = {
  // --- Banner Category ---
  getBannerCategories: async (params = {}) => {
    await delay(300);
    // Simple filter simulation
    let result = [...mockCategories];
    if (params.q) {
      result = result.filter(c => c.name.toLowerCase().includes(params.q.toLowerCase()));
    }
    result.sort((a, b) => a.displayOrder - b.displayOrder);
    return { data: { data: result, total: result.length } };
  },

  createBannerCategory: async (params = {}) => {
    await delay(300);
    const newCategory = { id: Date.now(), ...params, displayOrder: mockCategories.length + 1 };
    mockCategories = [newCategory, ...mockCategories];
    return { data: newCategory };
  },

  updateBannerCategory: async (id, params = {}) => {
    await delay(300);
    const index = mockCategories.findIndex(c => c.id === id);
    if (index > -1) {
      mockCategories[index] = { ...mockCategories[index], ...params };
    }
    return { data: true };
  },

  deleteBannerCategory: async (id) => {
    await delay(300);
    mockCategories = mockCategories.filter(c => c.id !== id);
    return { data: true };
  },

  updateBannerCategoryOrder: async (id, direction) => {
    await delay(300);
    const index = mockCategories.findIndex(c => c.id === id);
    if (index > -1) {
      if (direction === 'up' && index > 0) {
        const temp = mockCategories[index].displayOrder;
        mockCategories[index].displayOrder = mockCategories[index - 1].displayOrder;
        mockCategories[index - 1].displayOrder = temp;
        // swap in array
        const tempObj = mockCategories[index];
        mockCategories[index] = mockCategories[index - 1];
        mockCategories[index - 1] = tempObj;
      } else if (direction === 'down' && index < mockCategories.length - 1) {
        const temp = mockCategories[index].displayOrder;
        mockCategories[index].displayOrder = mockCategories[index + 1].displayOrder;
        mockCategories[index + 1].displayOrder = temp;
        // swap in array
        const tempObj = mockCategories[index];
        mockCategories[index] = mockCategories[index + 1];
        mockCategories[index + 1] = tempObj;
      }
    }
    return { data: true };
  },

  bulkUpdateBannerCategoryOrder: async (updates) => {
    await delay(300);
    updates.forEach(u => {
      const index = mockCategories.findIndex(c => c.id === u.id);
      if (index > -1) {
        mockCategories[index].displayOrder = u.displayOrder;
      }
    });
    return { data: true };
  },

  // --- Banner ---
  getBanners: async (params = {}) => {
    await delay(300);
    // Simple filter simulation
    let result = [...mockBanners];
    if (params.q) {
      result = result.filter(b => b.name.toLowerCase().includes(params.q.toLowerCase()));
    }
    if (params.status) {
      result = result.filter(b => b.status === params.status);
    }
    if (params.categoryId) {
      result = result.filter(b => b.categoryId === parseInt(params.categoryId));
    }
    result.sort((a, b) => a.displayOrder - b.displayOrder);
    
    // Attach category name
    const dataWithCategory = result.map(b => {
      const cat = mockCategories.find(c => c.id === b.categoryId);
      return { ...b, category: cat };
    });

    return { data: { data: dataWithCategory, total: dataWithCategory.length } };
  },

  createBanner: async (params = {}) => {
    await delay(300);
    const newBanner = { id: Date.now(), ...params, displayOrder: mockBanners.length + 1, status: params.status || 'ACTIVE' };
    mockBanners = [newBanner, ...mockBanners];
    return { data: newBanner };
  },

  updateBanner: async (id, params = {}) => {
    await delay(300);
    const index = mockBanners.findIndex(b => b.id === id);
    if (index > -1) {
      mockBanners[index] = { ...mockBanners[index], ...params };
    }
    return { data: true };
  },

  deleteBanner: async (id) => {
    await delay(300);
    mockBanners = mockBanners.filter(b => b.id !== id);
    return { data: true };
  },

  updateBannerOrder: async (id, direction) => {
    await delay(300);
    const index = mockBanners.findIndex(b => b.id === id);
    if (index > -1) {
      if (direction === 'up' && index > 0) {
        const temp = mockBanners[index].displayOrder;
        mockBanners[index].displayOrder = mockBanners[index - 1].displayOrder;
        mockBanners[index - 1].displayOrder = temp;
        // swap in array
        const tempObj = mockBanners[index];
        mockBanners[index] = mockBanners[index - 1];
        mockBanners[index - 1] = tempObj;
      } else if (direction === 'down' && index < mockBanners.length - 1) {
        const temp = mockBanners[index].displayOrder;
        mockBanners[index].displayOrder = mockBanners[index + 1].displayOrder;
        mockBanners[index + 1].displayOrder = temp;
        // swap in array
        const tempObj = mockBanners[index];
        mockBanners[index] = mockBanners[index + 1];
        mockBanners[index + 1] = tempObj;
      }
    }
    return { data: true };
  },

  bulkUpdateBannerOrder: async (updates) => {
    await delay(300);
    updates.forEach(u => {
      const index = mockBanners.findIndex(b => b.id === u.id);
      if (index > -1) {
        mockBanners[index].displayOrder = u.displayOrder;
      }
    });
    return { data: true };
  },
};

export default bannerApi;
